import RenderManager from "../rendering/render-manager";
import { computeFontSize } from "../2DObjects/TextLiveLabel";
import getStyle from "./get-style";
import { fire } from "./events";
import SlideManager from "./slide-manager";
import getLetterbox from "../helpers/get-letterbox";
import getVWKey from "../helpers/getVWKey";
import getRenderData from "../helpers/get-renderdata";
import screenSizes from "../../editor/constants/screenSizes";
import calcFov from "./calc-fov";
import Utils from "../utils";

let resizeTimeout = null;
function disableTransition() {
    document.body.classList.add("no-transition")
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        document.body.classList.remove("no-transition")
    }, 500)
}

function resize(e = {}) {
    if (!Q3.container) return;
    if (!Q3.editMode) disableTransition();
    const fsBtn = document.getElementById('fullscreen-button');
    if (!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement)) {
        if (Q3.controlsBox && window.location.href.indexOf("edit") > -1) {
            Q3.optionsBox.className = "hide-controls-box";
        }

        if (fsBtn) fsBtn.innerHTML = "&#xe5d0;";
    } else if (fsBtn) fsBtn.innerHTML = "&#xe5d1;";

    const { x, y } = RenderManager.getSize();
    let vw = x * 0.01;
    let vh = y * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vmin', `${Math.min(vw, vh)}px`);
    document.documentElement.style.setProperty('--vmax', `${Math.max(vw, vh)}px`);
    let letterbox = Q3.editMode ? null : getLetterbox(innerWidth, innerHeight);
    const rData = getRenderData(Q3.mobileView);

    Q3.windowSize = Object.keys(screenSizes).pop();
    Object.keys(screenSizes).reverse().forEach(s => {
        if (innerWidth <= screenSizes[s].width && innerHeight <= screenSizes[s].height) {
            Q3.windowSize = s;
        }
    });
    Q3.isMobileLandscape = innerWidth/innerHeight > 1 && innerWidth <= 1023;

    const unForceMobile = Utils.queryParams.has("un_force_mobile");

    if(unForceMobile){
        document.body.classList.remove('force-mobile');
    }else{
        document.body.classList[Q3.isMobileLandscape || Q3.browserCapabilities.isMobile ? "add" : "remove"]('force-mobile')
    }


    if (letterbox) {
        const app = document.getElementById("app");
        const viewer = document.getElementById("viewer");
        const layersLetterbox = document.getElementById("slide-layers-letterbox");
        if (Q3.teachMode) {
            const reducedHeight = Q3.teachMode === "teacher" && !Q3.teacherAssetMode
            const outerLetterBox = getLetterbox(innerWidth, innerHeight, reducedHeight);
            Object.assign(app.style, {
                left: `${outerLetterBox.x}px`,
                top: `${outerLetterBox.y}px`,
                width: `${outerLetterBox.w}px`,
                height: `${outerLetterBox.h}px`
            });

            Object.assign(viewer.style, {
                left: "0px",
                top: "0px",
                width: `${outerLetterBox.w}px`,
                height: `${outerLetterBox.h}px`
            });
            const innerLetterbox = getLetterbox(
              outerLetterBox.w,
              outerLetterBox.h
            );
            letterbox = {
                x: innerLetterbox.x,
                y: 0,
                w: innerLetterbox.w,
                h: innerLetterbox.h
            };
            [layersLetterbox].forEach(letterbox => {
                if (letterbox) {
                    Object.assign(letterbox.style, {
                        left: `${innerLetterbox.x}px`,
                        top: `${innerLetterbox.y}px`,
                        width: `${innerLetterbox.w}px`,
                        height: `${innerLetterbox.h}px`
                    });
                }
            });
        } else {
            const { x, y, w, h } = letterbox;
            Object.assign(app.style, {
                left: "0px",
                top: "0px",
                width: `${innerWidth}px`,
                height: `${innerHeight}px`
            });

            Object.assign(viewer.style, {
                left: "0px",
                top: "0px",
                width: `${innerWidth}px`,
                height: `${innerHeight}px`
            });

            [layersLetterbox].forEach(letterbox => {
                if (letterbox) {
                    Object.assign(letterbox.style, {
                        left: `${x}px`,
                        top: `${y}px`,
                        width: `${w}px`,
                        height: `${h}px`
                    });
                }
            });
        }
    }

    const style = getStyle();
    const isResized = (!Q3.editMode) || !Q3.editMode && (rData.top > 1e-3 || rData.left > 1e-3 || rData.width < 1 - 1e-3 || rData.height < 1 - 1e-3);
    const { width: canvasWidth, height: canvasHeight } = style;

    const fullWidth = Math.round(isResized ? letterbox.w : canvasWidth);
    const fullHeight = Math.round(isResized ? letterbox.h : canvasHeight);

    const offsetLeft = Math.round((isResized ? letterbox.x : 0) + rData.left * fullWidth);
    const offsetTop = Math.round((isResized ? letterbox.y : 0) + rData.top * fullHeight);

    const width = Math.round(fullWidth * rData.width);
    const height = Math.round(fullHeight * rData.height);

    const aspect = canvasWidth / canvasHeight;

    RenderManager.activeCamera.setViewOffset(canvasWidth, canvasHeight,
        (canvasWidth - canvasWidth) * 0.5,
        (canvasHeight - height) * 0.5 - offsetTop,
        canvasWidth, canvasHeight
    );

    RenderManager.activeCamera.aspect = aspect;
    RenderManager.setSize(canvasWidth, canvasHeight);
    RenderManager.setViewport(0, 0, canvasWidth, canvasHeight);
    RenderManager.setScissor(0, 0, canvasWidth, canvasHeight);

    if (RenderManager.background) RenderManager.background.setSize(canvasWidth, canvasHeight);

    if (!Q3.editMode) {
        RenderManager.activeCamera.fov = calcFov(SlideManager.currentSlide.camera.fov, canvasHeight / height);
        RenderManager.activeCamera.updateProjectionMatrix();
    }

    RenderManager.activeCamera.update = true;

    computeFontSize();
    setHtmlFontSize();

    if (Q3.layers) Q3.layers.forceUpdate();

    fire("viewportchanged");
}

function requestFullScreen() {
    const root = document.documentElement;
    const onResize = () => resize();

    if (root.requestFullscreen) root.requestFullscreen().then(onResize);
    else if (root.webkitRequestFullscreen) root.webkitRequestFullscreen().then(onResize);
    else if (root.mozRequestFullScreen) root.webkitRequestFullscreen().then(onResize);
    else if (root.msRequestFullscreen) root.msRequestFullscreen().then(onResize);
}

export default resize;
export { resize, checkRemActualSize, requestFullScreen };

function getHtmlFontSize() {
    let scale = 1;
    let w, h;
    let size = RenderManager.getSize();
    if (Q3.editMode) {
        w = size.width;
        h = size.height;
    } else if (Q3.layers) {
        w = Q3.letterbox.offsetWidth;
        h = Q3.letterbox.offsetHeight;
    }

    let side = w;

    if (getVWKey() === "sizeSm") { scale = 2.5; }

    return (side / 1920 * scale).toFixed(4);
}

function checkRemActualSize() {

    // let testEl = document.createElement("div");
    // document.body.appendChild(testEl);
    //
    // testEl.style.position= "absolute";
    // testEl.style.width = "100rem";
    //
    // let size = getHtmlFontSize();
    // if (Math.round(testEl.offsetWidth) !== Math.round(size*100)) {
    //     document.getElementById("app").remove();
    //     testEl.outerHTML = "<div style="position: absolute;width: 100%;top:  0;left: 0;height: 100%;background: #6495ed;color: white;font-size: 3vmax;text-align: center;display: flex;align-items: center;justify-content: center;">Your version of chrome is not supported, please update or reinstall.</div>"
    // } else {
    //     testEl.remove();
    // }
}


function setHtmlFontSize() {
    let pxSize = getHtmlFontSize() * 24;
    jQuery("html")[0].style.fontSize = `${pxSize}px`;
}
